import React from "react";
import styled from "styled-components";

function Footer() {
  return (
    <Container>
      <a
        href="https://www.buymeacoffee.com/ahjim"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
          alt="Buy Me A Coffee"
        />
      </a>
    </Container>
  );
}

const Container = styled.footer`
  z-index: 200;
  display: flex;
  justify-content: center;
  position: -webkit-sticky;
  position: sticky;
  bottom: 0px;
  left: 0;
  right: 0;
  a {
    img {
      height: calc(25px + 3vmin);
    }
  }
`;

export default Footer;
